const tenant = {
  state: {
    tenantInfo: JSON.parse(
      localStorage.getItem("tenantInfo") != "undefined"
        ? localStorage.getItem("tenantInfo")
        : ""
    ), 
  },
  mutations: {
    SET_TENANTINFO: (state, tenantInfo) => {
      state.tenantInfo = tenantInfo;
    },
  },
  actions: {
    setTenantInfo({ commit }, tenantInfo) {
      commit("SET_TENANTINFO", tenantInfo);
    },
  },
};
export default tenant;
